import { render, staticRenderFns } from "./suningPersonalInfoAuthorize.vue?vue&type=template&id=a1ea6e1a&scoped=true"
import script from "./suningPersonalInfoAuthorize.vue?vue&type=script&lang=js"
export * from "./suningPersonalInfoAuthorize.vue?vue&type=script&lang=js"
import style0 from "./suningPersonalInfoAuthorize.vue?vue&type=style&index=0&id=a1ea6e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ea6e1a",
  null
  
)

export default component.exports